module.exports = __webpack_public_path__ + "img/customer_design_10@2x.86bf1a0.jpg";